<template>
    <v-card>
    <div>
      <div class="filters">
        <input v-model="searchUser" placeholder="Buscar usuario" />
        <input v-model="searchActivity" placeholder="Buscar actividad" />
      </div>
      <table>
        <thead>
          <tr>
            <th>Día</th>
            <th>Usuario</th>
            <th>Actividad</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in filteredEntries" :key="entry.id">
            <td>{{ entry.day }}</td>
            <td>{{ entry.user }}</td>
            <td :class="`activity-cell ${entry.color}`">{{ entry.activity }}</td>
          </tr>
        </tbody>
      </table>
    </div>
</v-card>
  </template>
  
  <script>
  export default {
    data() {
      return {
        searchUser: "",
        searchActivity: "",
        schedule: [
          { id: 1, day: "Lunes", user: "Dr. Ricardo", activity: "Consulta", color: "blue" },
          { id: 2, day: "Martes", user: "Dra. Magda", activity: "Sala de Hemodiálisis", color: "green" },
        ],
      };
    },
    computed: {
      filteredEntries() {
        return this.schedule.filter(
          (entry) =>
            entry.user.toLowerCase().includes(this.searchUser.toLowerCase()) &&
            entry.activity.toLowerCase().includes(this.searchActivity.toLowerCase())
        );
      },
    },
  };
  </script>
  
  <style>
  .activity-cell.blue {
    background-color: lightblue;
  }
  .activity-cell.green {
    background-color: lightgreen;
  }
  .filters {
    margin-bottom: 10px;
  }
  </style>